import * as React from 'react';

export default function EnforceSetNewPasswordDialog(_: {
  shouldShow: boolean;
  onConfirm: () => void;
}) {
  return <></>;
}
